import React from 'react'

import pagenotfound from '../../assets/images/pagenotpound.webp'
export default function index() {
	return (
		<div style={{
			padding: "8.35%"
		}}>
			<img src={pagenotfound} style={{    display: "inline"}}></img>
			<h1>Page Not Found</h1>
		</div>
	)
}
